import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, message } from 'antd';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';

const { Title } = Typography;

const LoginSelector = () => {
  const navigate = useNavigate();
  const { loginWithRedirect, isAuthenticated, user } = useAuth0();
  const { login } = useContext(LoginContext);

  useEffect(() => {
    const autenticarCliente = async () => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/usuarios/login-cliente`, {
          usuario: user.email || user.sub,
          telefono: user.phone_number || null
        });

        const { usuario: usuarioBackend, token } = response.data;
        login({ ...usuarioBackend, token }); // Guardar en LoginContext
        navigate('/home');
      } catch (error) {
        console.error('Error al autenticar cliente:', error);
        message.error('Error al autenticar cliente');
      }
    };

    if (isAuthenticated && user) {
      autenticarCliente();
    }
  }, [isAuthenticated, user, login, navigate]);

  return (
    <div style={{ maxWidth: 600, margin: '100px auto', textAlign: 'center' }}>
      <img src="/logosuarez.png" alt="Shop Suarez" style={{ width: '200px', marginBottom: '2rem' }} />
      <Title level={3}>¿Cómo querés ingresar?</Title>
      <Row gutter={32} justify="center" style={{ marginTop: '2rem' }}>
        <Col xs={24} sm={12}>
          <Card
            hoverable
            style={{ padding: '2rem' }}
            onClick={() => loginWithRedirect()}
          >
            <Title level={4}>Cliente</Title>
          </Card>
        </Col>
        <Col xs={24} sm={12}>
          <Card
            hoverable
            style={{ padding: '2rem' }}
            onClick={() => navigate('/login-empresa')}
          >
            <Title level={4}>Empresa</Title>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LoginSelector;